import React, { useState } from 'react';
import styled from 'styled-components';
import DeliveriPNG from '../../../../../../generic/assets/delivery.png';
import CarSelector from '../../../../../../generic/ui/Selectors/CarSelector';
import { FormShell, FormField, FormFooter } from '../../../../../../generic/ui/FormLayout';
import { AccentButton } from '../../../../../../generic/ui/Button';
import { Mono } from '../../../../../../generic/ui/Mono';
import PhoneIcon from '../../../../../../generic/icons/IconLib/PhoneIcon';
import TruckIcon from '../../../../../../generic/icons/IconLib/TruckIcon';
import ScaleIcon from '../../../../../../generic/icons/IconLib/ScaleIcon';
import PalletIcon from '../../../../../../generic/icons/IconLib/PalletIcon';
import { ICarItem } from '../../../../../../modules/API/Defaults/models/cars';

interface Props {
    cars: ICarItem[];
    defaultCar: ICarItem | null;
    onSave: (car: ICarItem) => void;
    closeFunc?: (flag?: boolean) => void;
}

const ModalSelectDriver: React.FC<Props> = ({ cars, defaultCar, onSave }) => {
    const [selectedCar, setSelectedCar] = useState<ICarItem | null>(defaultCar ?? null);

    return (
        <FormShell>
            <TitleImg src={DeliveriPNG} alt='Driver' />
            <FormField label='נהג' fullWidth>
                <CarSelector
                    cars={cars}
                    value={selectedCar}
                    onSelect={setSelectedCar}
                />
            </FormField>
            {selectedCar && (
                <DetailsWrapper>
                    <DetailRow>
                        <DetailIcon>
                            <PhoneIcon size={16} color='currentColor' />
                        </DetailIcon>
                        <DetailValue>{selectedCar.Phone}</DetailValue>
                    </DetailRow>
                    <DetailRow>
                        <DetailIcon>
                            <TruckIcon size={16} color='currentColor' />
                        </DetailIcon>
                        <DetailValue>{selectedCar.CarNum}</DetailValue>
                    </DetailRow>
                    <DetailRow>
                        <DetailIcon>
                            <ScaleIcon size={16} color='currentColor' />
                        </DetailIcon>
                        <DetailValue>{selectedCar.Max_Weight}</DetailValue>
                    </DetailRow>
                    <DetailRow>
                        <DetailIcon>
                            <PalletIcon size={16} color='currentColor' />
                        </DetailIcon>
                        <DetailValue>{selectedCar.Pallets}</DetailValue>
                    </DetailRow>
                </DetailsWrapper>
            )}
            {selectedCar && (
                <FormFooter>
                    <AccentButton type='button' onClick={() => onSave(selectedCar)} fullWidth={false}>
                        עדכן
                    </AccentButton>
                </FormFooter>
            )}
        </FormShell>
    );
};

export default ModalSelectDriver;

const TitleImg = styled.img`
    width: 100%;
    max-width: 400px;
    align-self: center;
`;

const DetailsWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    direction: rtl;
    padding: 0 0.25rem;
`;

const DetailRow = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
`;

const DetailIcon = styled.span`
    display: inline-flex;
    align-items: center;
    color: ${({ theme }) => theme.colors.ink3};
    flex-shrink: 0;
`;

const DetailValue = styled(Mono)`
    font-size: ${({ theme }) => theme.text.md};
    color: ${({ theme }) => theme.colors.ink};
`;
